import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHashHistory from 'history/createHashHistory';
import { ConnectedRouter } from 'react-router-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import registerServiceWorker from './registerServiceWorker';
import { persistStore } from 'redux-persist'
import App from './App';
import configureStore from './store/configureStore';

injectTapEventPlugin();

const { store, history } = configureStore(createHashHistory(), window.__INITIAL_STATE__);

export default class AppProvider extends React.Component {

  constructor() {
    super()
    this.state = { rehydrated: false }
  }

  componentWillMount(){
  	this.persistor = persistStore(store, {
	      whitelist: ['status','customer','payever'], keyPrefix: 'gfdb:'
	    }, () => {
      this.setState({ rehydrated: true })
    })
  }

  render() {
    if(!this.state.rehydrated){
      return <div id="initloader">Loading...</div>
    }
    return (
      <Provider store={store} persistor={this.persistor}>
	    <ConnectedRouter history={history}>
	      <App />
	    </ConnectedRouter>
	  </Provider>
    )
  }
}

ReactDOM.render(
	<AppProvider />,
	document.getElementById('root')
);
if(process.env.NODE_ENV !== 'production'){
	registerServiceWorker();
}


// WEBPACK FOOTER //
// ./src/index.js